/**
 * Plain-text transcript document from an inbox conversation payload.
 */
export class TranscriptDocumentBuilder {
  build(conversation) {
    const conv = conversation && typeof conversation === "object" ? conversation : {};
    const user = conv.user && typeof conv.user === "object" ? conv.user : {};
    const owner = String(conv.assignee || "Unassigned").trim() || "Unassigned";
    const headerLines = [
      `Session ID: ${String(conv.id || conv.visitorSessionId || "").trim()}`,
      `Visitor: ${String(user.name || "Visitor").trim()}`,
      `Email: ${String(user.email || "").trim() || "—"}`,
      `Workspace: ${String(conv.workspaceName || conv.workspaceId || "—").trim()}`,
      `Owner: ${owner}`,
      `Status: ${String(conv.status || "open").trim()}`,
      "",
    ];
    const messages = Array.isArray(conv.messages) ? conv.messages : [];
    const body = messages.map((msg) => this._formatMessage(msg)).filter(Boolean);
    return [...headerLines, ...body].join("\n");
  }

  safeFileStem(sessionId) {
    const raw = String(sessionId || "session").trim() || "session";
    return raw.replace(/[^a-zA-Z0-9._-]+/g, "_").slice(0, 80);
  }

  _formatMessage(msg) {
    if (!msg || typeof msg !== "object") return "";
    const sender = this._senderLabel(msg);
    const time = String(msg.time || msg.sentAt || "").trim();
    const text = String(msg.text || "").replace(/\r\n/g, "\n").trim();
    const stamp = time ? ` (${time})` : "";
    return `${sender}${stamp}:\n${text}`;
  }

  _senderLabel(msg) {
    const sender = String(msg.sender || "").toLowerCase();
    if (sender === "user") return "Customer";
    if (sender === "agent") return "Agent";
    if (sender === "bot" || sender === "ai") return "Bot";
    if (sender === "note") return "Note";
    if (sender === "system" || msg.type === "system") return "System";
    return "Message";
  }
}
